import { render, staticRenderFns } from "./reporteestudiantebarra.vue?vue&type=template&id=129f430a"
import script from "./reporteestudiantebarra.vue?vue&type=script&lang=js"
export * from "./reporteestudiantebarra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports